module.exports = __webpack_public_path__ + "media/images/green_light-1e7d1ac3580d699f7b4100c56a5534c5.png";